import { Pipe, PipeTransform } from '@angular/core';
import { CodeService } from '../../shared/init/code.service';

@Pipe({
  name: 'commonCode',
})
export class CommonCodePipe implements PipeTransform {
  constructor(private codeService: CodeService) {}

  transform(code: string | string[], mainCode: string): any {
    if (Array.isArray(code)) {
      return code.map((c) => {
        const o = this.codeService.getCommonCode(mainCode, c);
        return o ? o.value : '';
      });
    } else {
      const o = this.codeService.getCommonCode(mainCode, code);
      return o ? o.value : '';
    }
  }
}
